export default __webpack_public_path__ + "static/media/statusCancelled.3e2e334f.png";